'use strict';
var RxCredentialListController = /** @class */ (function () {
    /*@ngInject*/
    function RxCredentialListController($scope, $mdDialog, $cookies, $timeout, Upload, Util, Auth, RxCredentialListService, $window, PageLevelAlertMessagingService, googleAnalytic, RxCredentialEvents) {
        this.sortType = 'orderDate';
        this.sortReverse = false;
        this.searchOrderDate = '';
        this.credentialType = null;
        this.selectedRxCredential = null;
        this.files = null;
        this.file = null;
        this.log = null;
        this.progressPercentage = 0;
        this.credentialBeingEdited = null;
        this.credentialAddFormValid = false;
        this.rxCredentialValid = false;
        this.rxCredential = false;
        this.showAlert = false;
        this.loadingBar = false;
        this.closeAlertMessage = function () {
            this.showAlert = false;
        };
        this.$scope = $scope;
        this.Upload = Upload;
        this.$cookies = $cookies;
        this.$timeout = $timeout;
        this.$mdDialog = $mdDialog;
        this.rxCredentialListService = RxCredentialListService;
        this.$window = $window;
        this.Util = Util;
        this.Auth = Auth;
        this.PageLevelAlertMessagingService = PageLevelAlertMessagingService;
        this.GoogleAnalyticsService = googleAnalytic;
        this.RxCredentialsEvents = RxCredentialEvents;
        var self = this;
        self.setRxCredentialWarningContent();
        self.credentials = [{}];
        self.refreshCredentialsList();
        self.loadingBar = true;
        this.rxCredentialListService.getRxDoctorTypes().then(function (response) {
            self.loadingBar = false;
            self.credentialTypes = response.data.response.currentPage;
        });
        $scope.$watch('$ctrl.file', function () {
            if (self.file != null && self.selectedRxCredential != null) {
                if (self.files == null)
                    self.files = [];
                self.files.push(self.file);
                self.selectedRxCredential.status = 'Upload Pending';
                self.selectedRxCredential.file = self.file;
            }
        });
        $scope.$on('credentialUploaded', function (event, data) {
            self.refreshCredentialsList();
        });
        $scope.$on('credentialAddFormValid', function (event, data) {
            self.credentialAddFormValid = data;
            self.rxCredentialValid = self.rxCredentialListService.getValid();
        });
        self.log = '';
        self.uploadError = false;
        self.uploadErrorMsg = '';
    }
    RxCredentialListController.prototype.setRxCredentialWarningContent = function () {
        this.rxCredentialContentPara1 = "Prescription products are available in most states to Qualified Healthcare\n                                     Practitioners. Please indicate if you would like access to Rx products. Due to\n                                     special licensing requirements that vary by state, you will either need to add a\n                                     new credential or edit your previously submitted credential to provide additional\n                                     needed details including Type, License Number, State and Expiration. Your\n                                     credentials will be sent for additional review. If approved, your access will be\n                                     updated within 48 hours.";
    };
    RxCredentialListController.prototype.refreshCredentialsList = function () {
        var self = this;
        self.loadingBar = true;
        this.rxCredentialListService.getCredentials().then(function (response) {
            self.loadingBar = false;
            if (response.status == 200 && response.data) {
                self.rxCredentialsList = response.data;
                var i;
                for (i in self.rxCredentialsList) {
                    if (self.rxCredentialsList[i].credentialType == null) {
                        self.rxCredentialsList[i].credentialType = 'Other';
                    }
                }
            }
        });
    };
    RxCredentialListController.prototype.addCredential = function (event) {
        var self = this;
        self.credentials = [];
        self.credentials.push(event.credential);
        self.loadingBar = true;
        self.$scope.$broadcast('AddCredentialStarted', true);
        self.upload(event.credential);
        self.credentialAddFormValid = false;
    };
    RxCredentialListController.prototype.editCredential = function (credentialId) {
        this.credentialBeingEdited = credentialId;
    };
    RxCredentialListController.prototype.upload = function (credential) {
        this.Auth.clearAccountCache();
        var self = this;
        if (credential) {
            if (!credential.$error && (self.rxCredential ? credential.credentialType != null : true)) {
                var xsrf_token = this.$cookies.get('XSRF-TOKEN');
                self.Upload.upload({
                    url: '/api/account/rx',
                    method: 'POST',
                    headers: {
                        'X-XSRF-TOKEN': xsrf_token
                    },
                    data: {
                        credentialType: credential.credentialType,
                        doctorTypeId: credential.doctorType.doctorTypeID,
                        doctorTypeKey: credential.doctorType.doctorTypeKey,
                        licenseNumber: credential.licenseNumber,
                        expirationDate: credential.expirationDate,
                        stateIssued: credential.stateIssued,
                        file: credential.file
                    }
                }).then(function (resp) {
                    self.$timeout(function () {
                        var mesg = '';
                        if (resp.status == 200 && resp.config.data.file) {
                            mesg = 'file: ' +
                                resp.config.data.file.name;
                        }
                        mesg = mesg + ', Response: ' + JSON.stringify(resp.data) + '\n';
                        credential.status = 'PENDING REVIEW';
                        self.loadingBar = false;
                        if (resp.status != 200 || (resp.data && resp.data.errors && resp.data.errors.length)) {
                            self.Util.handleApiError(resp, self);
                            self.$scope.$broadcast('AddCredentialError', resp);
                        }
                        else {
                            // Analytics - GTM Integration
                            var eventData = self.RxCredentialsEvents.practitionerCredentialEvents['uploadCredential'];
                            self.GoogleAnalyticsService.sendGTMEvent(eventData, {
                                practitionerId: self.Auth.getLoggedInUser().customerId
                            });
                            self.Util.resetApiError(self);
                            self.$scope.$broadcast('AddCredentialFinished', true);
                            self.closeDialog();
                            self.refreshCredentialsList();
                        }
                    });
                }, function (resp) {
                    credential.status = 'UPLOAD FAILED';
                    self.loadingBar = false;
                    if (resp.status != 200 || (resp.data && resp.data.errors && resp.data.errors.length)) {
                        self.$scope.$broadcast('AddCredentialError', resp);
                        self.Util.handleApiError(resp, self);
                    }
                }, function (evt) {
                    self.progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
                    var mesglog = 'progress: ' + self.progressPercentage + '% ' + evt.config.data.file.name + '\n';
                    self.uploadError = true;
                    self.uploadErrorMsg = 'UPLOADING';
                    credential.status = 'UPLOADING';
                });
            }
        }
    };
    RxCredentialListController.prototype.changeCredType = function (credential) {
        this.selectedRxCredential = credential;
    };
    RxCredentialListController.prototype.closeDialog = function (modalId) {
        this.$scope.$broadcast('clearForm', {});
        this.PageLevelAlertMessagingService.isModalOpen = false;
        if (modalId) {
            this.$mdDialog.hide({ contentElement: modalId });
        }
        else {
            this.$mdDialog.hide();
        }
        this.$scope.$broadcast('addCredentialsFormReset', {});
    };
    RxCredentialListController.prototype.submitForm = function ($event) {
        $event.preventDefault();
        this.action = 'Add';
        this.$scope.$broadcast('submitForm', {});
    };
    RxCredentialListController.prototype.isFormValid = function () {
        return this.credentialAddFormValid;
    };
    return RxCredentialListController;
}());
export default RxCredentialListController;
//# sourceMappingURL=rx-credential-list.controller.js.map